/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

import Icon from 'shared/Icon';

import * as S from './styles';

interface IStarRating {
  value: number;
  onChange(rating: number): void;
}

const RATING_LABELS = ['Muito insatisfeito', 'Insatisfeito', 'Neutro', 'Satisfeito', 'Muito Satisfeito'];

const StarRating: React.FC<IStarRating> = ({ value, onChange }) => {
  const [hoveredRating, setHoveredRating] = useState<number>(0);

  const highlightedRating = hoveredRating || value;

  return (
    <S.RatingRow onMouseLeave={() => setHoveredRating(0)}>
      {RATING_LABELS.map((label, index) => {
        const rating = index + 1;

        return (
          <S.RatingOption
            key={label}
            type="button"
            aria-label={`${rating} - ${label}`}
            aria-pressed={value === rating}
            data-testid={`satisfactionSurveyRating_${rating}`}
            onMouseEnter={() => setHoveredRating(rating)}
            onFocus={() => setHoveredRating(rating)}
            onClick={() => onChange(rating)}
          >
            <Icon
              name="star"
              width="32"
              height="32"
              color="#4A4A4A"
              strokeWidth={2}
              fill={rating <= highlightedRating ? '#F5EF4E' : 'none'}
            />
            <span>
              {rating}
              <br />
              {label}
            </span>
          </S.RatingOption>
        );
      })}
    </S.RatingRow>
  );
};

export default StarRating;
